// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uHnI","question":"styles_question__2ZpEk","description":"styles_description__1O6kl"};